module.exports = __webpack_public_path__ + "static/img/5.dea9560.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/5.jpg
// module id = Ozqu
// module chunks = 0